// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

export const maybeUnknownState = {
  TRUE: true,
  FALSE: false,
  UNKNOWN: "unknown",
};
